<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Publications des professeurs" />
            <LesPublications/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesPublications from './LesPublications.vue';


export default {
    name: 'PublicationPage',
    components: {
        NavBar,
        PageTitle,
        LesPublications,
        FooterComp,
    }
}
</script>